import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { transformAnswers } from "./NeedsBasedQuestion.helpers.js";
function NeedsBasedQuestion({
  questionId,
  parentQuestionId,
  description,
  answer,
  onChangeCallback,
  value,
  QuestionComponent,
  ScriptingContainer,
  required,
  hasError
}) {
  const chipOptions = useMemo(() => transformAnswers(answer == null ? void 0 : answer.answers), [answer]);
  const isMultiselect = (answer == null ? void 0 : answer.__typename) === "MultiChoiceMultiAnswer";
  return /* @__PURE__ */ jsxs("section", { "data-test-id": `section_needs_based_question_${questionId}`, children: [
    /* @__PURE__ */ jsx(
      ScriptingContainer,
      {
        dataTestPostfix: questionId,
        questionText: description,
        required,
        value,
        hasError
      }
    ),
    /* @__PURE__ */ jsx("section", { "data-test-id": `section_chipList_container_${questionId}`, children: /* @__PURE__ */ jsx(
      QuestionComponent,
      {
        multiselect: isMultiselect,
        options: chipOptions,
        onChange: (buttonValue) => onChangeCallback(buttonValue, questionId, parentQuestionId),
        onChangeMulti: (buttonValue) => onChangeCallback(buttonValue, questionId, parentQuestionId),
        dataTestIdSuffix: questionId,
        value,
        hasError
      }
    ) })
  ] });
}
export {
  NeedsBasedQuestion as default
};
